import { render, staticRenderFns } from "./EducationEventBookForm.vue?vue&type=template&id=0ad0fa80&"
import script from "./EducationEventBookForm.vue?vue&type=script&lang=ts&"
export * from "./EducationEventBookForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports